__turbopack_context__.v({
  "dots": "ImageGenerationPreview-module__EFpvxG__dots",
  "elapsed": "ImageGenerationPreview-module__EFpvxG__elapsed",
  "image": "ImageGenerationPreview-module__EFpvxG__image",
  "placeholder": "ImageGenerationPreview-module__EFpvxG__placeholder",
  "preview": "ImageGenerationPreview-module__EFpvxG__preview",
  "surface": "ImageGenerationPreview-module__EFpvxG__surface",
});
